import { useState, useEffect, useCallback } from "react"

export const useDebounceHook = <T>(value: T, delay: number): T => {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)

    const updateDebouncedValue = useCallback(() => {
        setDebouncedValue(value)
    }, [value]) // Only recreate if value changes

    useEffect(() => {
        const timeout = setTimeout(updateDebouncedValue, delay)

        return () => clearTimeout(timeout)
    }, [value, delay, updateDebouncedValue])

    return debouncedValue
}
